var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 51,
    height: 34.613,
    viewBox: "0 0 51 34.613",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.8325 3.33544C47.4491 0.906232 45.9478 0.459409 42.891 0.289491C39.8374 0.0849592 32.1587 0 25.5064 0C18.8413 0 11.1594 0.0849595 8.109 0.286344C5.05856 0.459409 3.55406 0.903085 2.15794 3.33544C0.733125 5.76149 0 9.94023 0 17.2971V17.3222C0 24.6476 0.733125 28.8578 2.15794 31.2587C3.55406 33.6879 5.05538 34.1284 8.10581 34.333C11.1594 34.5092 18.8413 34.613 25.5064 34.613C32.1587 34.613 39.8374 34.5092 42.8942 34.3361C45.951 34.1316 47.4523 33.6911 48.8357 31.2618C50.2733 28.861 51 24.6508 51 17.3254V17.3002C51 9.94023 50.2733 5.76149 48.8325 3.33544ZM19.125 26.7464V7.86659L35.0625 17.3065L19.125 26.7464Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d75c7ff752f4519c7c074328de1860b1.svg";
export { ForwardRef as ReactComponent };